import { usersRepository } from "@/repositories/users.repository"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const REQUEST_OTP_KEY = 'request_otp'
const VERIFY_EMAIL_KEY = 'verify_email'
const VERIFY_TELEGRAM_KEY = 'verify_telegram'

export const useVerify = () => {
    const queryClient = useQueryClient()

    const requestEmailMutation = useMutation({
        mutationKey: [REQUEST_OTP_KEY],
        mutationFn: () => usersRepository.requestEmailVerification()
    })

    const verifyEmailMutation = useMutation({
        mutationKey: [VERIFY_EMAIL_KEY],
        mutationFn: (otp: string) => usersRepository.verifyEmail(otp),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user'] })
        }
    })

    const verifyTelegramMutation = useMutation({
        mutationKey: [VERIFY_TELEGRAM_KEY],
        mutationFn: (otp: string) => usersRepository.linkTelegram(otp),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user'] })
        }
    })

    return {
        requestEmail: requestEmailMutation.mutate,
        verifyEmail: verifyEmailMutation.mutate,
        verifyTelegram: verifyTelegramMutation.mutate,
        verifyEmailPending: verifyEmailMutation.isPending,
        verifyEmailSuccess: verifyEmailMutation.isSuccess,
        verifyEmailError: verifyEmailMutation.error,
        verifyTelegramPending: verifyTelegramMutation.isPending,
        verifyTelegramSuccess: verifyTelegramMutation.isSuccess,
        verifyTelegramError: verifyTelegramMutation.error,
    }
}